/* eslint-disable jsx-a11y/alt-text */
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, EffectCreative } from "swiper/modules";
import { Fragment, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { useAtomValue } from "jotai";
import { mobileAtom } from "../stores/layout";
import { INTRODUCTIONS } from "../constants/main";
import FramePc from "../components/icons/frame-pc";
import FrameMob from "../components/icons/frame-mob";
import { mousewheel } from "../App";

const Section2 = ({ onSlideChange }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const clippingMaskRef = useRef(null);
  const isMobile = useAtomValue(mobileAtom);

  const Frame = isMobile ? FrameMob : FramePc;

  const handleChangeSlide = (targetSwiper) => {
    setActiveIndex(targetSwiper.activeIndex || 0);
    onSlideChange(targetSwiper);
  };

  useEffect(() => {
    clippingMaskRef.current?.animate(
      {
        height: ["75%", "100%"],
      },
      { duration: 300, delay: 0, fill: "forwards" }
    );
  }, [clippingMaskRef, activeIndex]);

  return (
    <>
      <Swiper
        className="introduce"
        direction="vertical"
        mousewheel={mousewheel}
        nested
        effect="creative"
        creativeEffect={{
          prev: {
            translate: [0, 0, 0],
          },
          next: {
            translate: [0, "-25%", 0],
          },
        }}
        preventInteractionOnTransition
        modules={[EffectCreative, Mousewheel]}
        onSlideChange={handleChangeSlide}
      >
        <SwiperSlide className="bg_color_1"></SwiperSlide>
        <SwiperSlide className="bg_color_2"></SwiperSlide>
        <SwiperSlide className="bg_color_3"></SwiperSlide>
      </Swiper>
      <div className="container fixed_box">
        {[0, 1, 2].map((i) => (
          <Fragment key={`item_${i}`}>
            <div
              className={clsx("text_wrap", {
                white: activeIndex === 0,
              })}
              style={{ display: activeIndex === i ? "flex" : "none" }}
            >
              <h4 className="sticky_title animated_text">
                {INTRODUCTIONS[i].title}
              </h4>
              <h5 className="sticky_desc animated_text delay">
                {INTRODUCTIONS[i].description}
              </h5>
            </div>
            <div
              className="introduce_item"
              key={`item_${i}`}
              style={{ display: activeIndex === i ? "flex" : "none" }}
            >
              <img
                src={`//www.locknlock.com/eng/image/common/about/brand/img${
                  i + 1
                }.png`}
                className="inner_bg"
                decoding="async"
                ref={activeIndex === i ? clippingMaskRef : undefined}
              />
              <Frame className="frame" />
            </div>
          </Fragment>
        ))}
      </div>
    </>
  );
};

export default Section2;
